import { render, staticRenderFns } from "./GroupRegainsubPhone.vue?vue&type=template&id=a7ffb000&scoped=true&"
import script from "./GroupRegainsubPhone.vue?vue&type=script&lang=js&"
export * from "./GroupRegainsubPhone.vue?vue&type=script&lang=js&"
import style0 from "./GroupRegainsubPhone.vue?vue&type=style&index=0&id=a7ffb000&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ffb000",
  null
  
)

export default component.exports